module.exports = __webpack_public_path__ + "img/1482135314156.ed007a69.jpg";